import React from "react";
import { orderBy, template } from "lodash";
// types
import { TMainPageLayoutV2 } from "../type";
// components
import RMDRLink from "@/components/RMDRLink";
import RMDRImage from "@/components/RMDRImage";
import RMDRComponentSanitizer from "@/components/RMDRComponentSanitizer";
// hooks
import useContent from "@/hooks/useContent";
// utilities
import { 
    metaDataLanguageVersion, 
    outerNameDescriptionLanguageVersion,
    redirectUrl 
} from "@/utilities/LanguageVersionSelectorShortcut";
import LanguageVersionSelector from "@/utilities/LanguageVersionSelector";
// enums
import EResourceType from "@/cms/enums/EResourceType";
import EViewType from "@/cms/enums/EViewType";
import EContentType from "@/cms/enums/EContentType";
import EView from "@/cms/enums/EView";
// types
import TLanguageVersionList from "@/cms/types/TLanguageVersionList";
import TLanguageVersionDetail from "@/cms/types/TLanguageVersionDetail";
import TClientContentDetail from "@/cms/types/TClientContentDetail";
import TClientPageDetail from "@/cms/types/TClientPageDetail";
import TClientMainPageItemList from "@/cms/types/TClientMainPageItemList";


type TMNPG022 = {
    contentDetails:TClientContentDetail|TClientPageDetail|null;
}

const Render = ( props:{ contentDetails:TClientContentDetail|TClientPageDetail|null, template:TClientMainPageItemList } ) => {
    if ( !props.contentDetails ) return null;

    const languageVersion = outerNameDescriptionLanguageVersion(props.contentDetails.languageVersions);
    const _redirectUrl = redirectUrl(props.contentDetails.languageVersions);
    const readMoreString = metaDataLanguageVersion("readMoreString", props.contentDetails.languageVersions);

    const innerLanguageVersion = orderBy(LanguageVersionSelector<TLanguageVersionList[]|TLanguageVersionDetail[]|undefined>({
        languageVersions: props.contentDetails.languageVersions,
        filters: [
            { view: EView.INNER, viewType: EViewType.TEXT, contentType: EContentType.PAGE }
        ],
        type: "filter"
    }), ["order"], ["asc"]);

    return (
        <div className="row">
            <div className="col col-lg-4 col-12">
                <div className="left-col">
                    <div className="section-title">
                        <div className="icon">
                            <RMDRImage 
                                resources={props.contentDetails.resources}
                                resourceType={EResourceType.ICON}
                                alt={languageVersion?.name}
                                title={languageVersion?.name}
                            />
                        </div>
                        <span>{innerLanguageVersion?.[0]?.name}</span>
                        <RMDRComponentSanitizer 
                            languageVersion={innerLanguageVersion?.[0]}
                            variant="div"
                            valueExpr="value"
                        />
                        <RMDRLink
                            text={""}
                            title={readMoreString}
                            hasNavigationDestination={props.template?.hasDestinationNavigation}
                            navigationURL={languageVersion?.contentRouteNavigationURL}
                            redirectType={props.template?.redirectType}
                            redirectUrl={_redirectUrl?.value}
                            className="more-about"
                        >
                            {readMoreString} <i className="fi flaticon-next-1"></i>
                        </RMDRLink>
                    </div>
                </div>
            </div>
            <div className="col col-lg-4 col-12">
                <div className="mid-col">
                    <RMDRImage
                        resourceType={EResourceType.OUTER_IMAGE}
                        resources={props.contentDetails.resources} 
                        alt={languageVersion?.name} 
                        title={languageVersion?.name}
                    />
                </div>
            </div>
            <div className="col col-lg-4 col-12">
                <RMDRComponentSanitizer
                    languageVersion={innerLanguageVersion?.[1]}
                    variant="div"
                    valueExpr="value"
                    className="right-col first-uppercase"
                />
            </div>
        </div>
    )
}

const RenderOwnContent = ( props:{unqKey:string, contentId:string, template:TClientMainPageItemList} ) => {
    
    const contentDetails = useContent({unqKey:`${props.unqKey}CD`, id:props.contentId});
    return <Render contentDetails={contentDetails} template={props.template} />

}

const MNPG022 = ( props: TMainPageLayoutV2<TMNPG022> ) => {
    console.log("MNPG022.rendered", props);

    if ( props.contentDetails && props.template ) {
        return <Render contentDetails={props.contentDetails} template={props.template} />
    }
    else if ( props.template ) {
        const unqKey = props.template.id.split("-")[4];
        return <RenderOwnContent unqKey={unqKey} contentId={props.template.contentId} template={props.template} />
    }

    return null;
}

const Component = React.memo(MNPG022, ( prevProps:TMainPageLayoutV2<TMNPG022>, nextProps:TMainPageLayoutV2<TMNPG022> ) => {
    console.log("MNPG022.memo", { prevProps, nextProps });
    return true;
});

export default Component;
